<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Manual Backup</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form>
          <div class="alert alert-warning" role="alert">
            <b>Note:</b> When performing a backup, please allow a few seconds for the backup process to complete.
          </div>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="backup.name">
          </div>
          <div class="form-group">
            <label for="ddlLocation">Location</label>
            <select class="form-control" id="ddlLocation" v-model="backup.backup_location_id">
              <option value="0">Select..</option>
              <option v-for="backup_location in backup_locations"
                      :key="backup_location.backup_location_id"
                      v-bind:value="backup_location.backup_location_id">{{ backup_location.name
                }}
              </option>
            </select>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="performBackup(backup)">Backup</button>
        </form>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <p>
          <b>Manual Backup Naming Conventions </b>
        </p>
        <p>
          Recommended naming conventions for "Manual" backups are Date_Time using hyphens "-" between the digits.
        </p>
        Example:
        <ul>
          <li>May 21, 2018 9:45 AM would read 5-21-18_9-45-am</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      backup: {
        name: '',
        backup_location_id: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      backup_locations: 'allBackupLocations'
    })
  },
  created () {
    this.$store.dispatch('getBackupLocations')
  },
  methods: {
    ...mapActions([
      'performBackup'
    ])
  }
}
</script>

<style scoped>

</style>
